import { CodeBase } from "./_codeBase";



/**
 * 立会作業区分
 */
export class AttendantWorkDiv extends CodeBase<AttendantWorkDiv>
{
    /** 立会作業区分: "01", "立会1"*/
    public static readonly AW_1: AttendantWorkDiv = new AttendantWorkDiv("01", "立会1", "");

    /** 立会作業区分: "02", "立会2"*/
    public static readonly AW_2: AttendantWorkDiv = new AttendantWorkDiv("02", "立会2", "");

    /** 立会作業区分: "03", "立会3"*/
    public static readonly AW_3: AttendantWorkDiv = new AttendantWorkDiv("03", "立会3", "");

    /** 立会作業区分: "04", "立会4"*/
    public static readonly AW_4: AttendantWorkDiv = new AttendantWorkDiv("04", "立会4", "");

    /** 立会作業区分: "05", "立会5"*/
    public static readonly AW_5: AttendantWorkDiv = new AttendantWorkDiv("05", "立会5", "");

    /** 立会作業区分: "06", "立会6"*/
    public static readonly AW_6: AttendantWorkDiv = new AttendantWorkDiv("06", "立会6", "");

    /** 立会作業区分: "07", "立会7"*/
    public static readonly AW_7: AttendantWorkDiv = new AttendantWorkDiv("07", "立会7", "");

    /** 立会作業区分: "08", "立会8"*/
    public static readonly AW_8: AttendantWorkDiv = new AttendantWorkDiv("08", "立会8", "");

    /** 立会作業区分: "09", "立会9"*/
    public static readonly AW_9: AttendantWorkDiv = new AttendantWorkDiv("09", "立会9", "");

    /** 立会作業区分: "10", "立会10"*/
    public static readonly AW_10: AttendantWorkDiv = new AttendantWorkDiv("10", "立会10", "");

    /** 立会作業区分: "11", "立会11"*/
    public static readonly AW_11: AttendantWorkDiv = new AttendantWorkDiv("11", "立会11", "");

    /** 立会作業区分: "12", "立会12"*/
    public static readonly AW_12: AttendantWorkDiv = new AttendantWorkDiv("12", "立会12", "");

    /** 立会作業区分: "13", "立会13"*/
    public static readonly AW_13: AttendantWorkDiv = new AttendantWorkDiv("13", "立会13", "");

    /** 立会作業区分: "14", "立会14"*/
    public static readonly AW_14: AttendantWorkDiv = new AttendantWorkDiv("14", "立会14", "");

    /** 立会作業区分: "15", "立会15"*/
    public static readonly AW_15: AttendantWorkDiv = new AttendantWorkDiv("15", "立会15", "");

    /** 立会作業区分: "16", "立会16"*/
    public static readonly AW_16: AttendantWorkDiv = new AttendantWorkDiv("16", "立会16", "");

    /** 立会作業区分: "17", "立会17"*/
    public static readonly AW_17: AttendantWorkDiv = new AttendantWorkDiv("17", "立会17", "");

    /** 立会作業区分: "18", "立会18"*/
    public static readonly AW_18: AttendantWorkDiv = new AttendantWorkDiv("18", "立会18", "");

    /** 立会作業区分: "19", "立会19"*/
    public static readonly AW_19: AttendantWorkDiv = new AttendantWorkDiv("19", "立会19", "");

    /** 立会作業区分: "20", "立会20"*/
    public static readonly AW_20: AttendantWorkDiv = new AttendantWorkDiv("20", "立会20", "");

    /** 立会作業区分: "21", "立会21"*/
    public static readonly AW_21: AttendantWorkDiv = new AttendantWorkDiv("21", "立会21", "");

    /** 立会作業区分: "22", "立会22"*/
    public static readonly AW_22: AttendantWorkDiv = new AttendantWorkDiv("22", "立会22", "");

    /** 立会作業区分: "23", "立会23"*/
    public static readonly AW_23: AttendantWorkDiv = new AttendantWorkDiv("23", "立会23", "");

    /** 立会作業区分: "24", "立会24"*/
    public static readonly AW_24: AttendantWorkDiv = new AttendantWorkDiv("24", "立会24", "");

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): AttendantWorkDiv[] {
        return [
            AttendantWorkDiv.AW_1,
            AttendantWorkDiv.AW_2,
            AttendantWorkDiv.AW_3,
            AttendantWorkDiv.AW_4,
            AttendantWorkDiv.AW_5,
            AttendantWorkDiv.AW_6,
            AttendantWorkDiv.AW_7,
            AttendantWorkDiv.AW_8,
            AttendantWorkDiv.AW_9,
            AttendantWorkDiv.AW_10,
            AttendantWorkDiv.AW_11,
            AttendantWorkDiv.AW_12,
            AttendantWorkDiv.AW_13,
            AttendantWorkDiv.AW_14,
            AttendantWorkDiv.AW_15,
            AttendantWorkDiv.AW_16,
            AttendantWorkDiv.AW_17,
            AttendantWorkDiv.AW_18,
            AttendantWorkDiv.AW_19,
            AttendantWorkDiv.AW_20,
            AttendantWorkDiv.AW_21,
            AttendantWorkDiv.AW_22,
            AttendantWorkDiv.AW_23,
            AttendantWorkDiv.AW_24,
        ];
    }
}
